import { RANK_VALUE_TO_DISPLAY } from '../../constants';

// moved separately from the component file to make it easy to mock in tests
export const SELECT_VALUE_TO_DISPLAY_MAPS_FOREACH_AGG = {
  Rank: RANK_VALUE_TO_DISPLAY,
};
